import type { App } from "vue"
import { SimpleKeyboard } from "@zodance/ui"
import "@zodance/ui/dist/index.css"

export function loadSimpleKeyboard(app: App) {
  app.component("SimpleKeyboard", SimpleKeyboard)
}

export default SimpleKeyboard
